import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router';
import { Box, CircularProgress, Typography } from '@mui/material';

const isStaging = process.env.REACT_APP_AIME_SERVER_URL?.includes('staging');
const AIME_SCHEME = isStaging ? 'aime.stg://' : 'aime://';
const APP_STORE_ID = '6740821752';
const APP_STORE_URL = `https://apps.apple.com/us/app/aime-ai-assistant/id${APP_STORE_ID}`;

const AimeThreadRedirect = () => {
  const { threadId } = useParams();
  const [searchParams] = useSearchParams();
  const sfUrl = searchParams.get('sf_url');
  const [error, setError] = useState(null);
  const [showSpinner, setShowSpinner] = useState(true);
  const [message, setMessage] = useState('Opening AIMe...');

  useEffect(() => {
    const isMobile = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isMobile) {
      const deepLink = `${AIME_SCHEME}chat/${threadId}`;
      let appOpened = false;

      const handleBlur = () => {
        appOpened = true;
      };

      window.addEventListener('blur', handleBlur);

      // Attempt to open the app
      window.location.href = deepLink;

      // Update message after 2 seconds
      const messageTimeout = setTimeout(() => {
        setMessage('You can close this tab.');
        setShowSpinner(false);
      }, 2000);

      // Fallback to App Store if app didn't open
      const fallbackTimeout = setTimeout(() => {
        if (!appOpened) {
          window.location.href = APP_STORE_URL;
        }
      }, 3000);

      return () => {
        clearTimeout(fallbackTimeout);
        clearTimeout(messageTimeout);
        window.removeEventListener('blur', handleBlur);
      };

    } else {
      // Desktop: redirect to Salesforce
      if (!sfUrl) {
        setError('Missing Salesforce URL parameter');
        return;
      }

      setMessage('Redirecting to Salesforce...');
      const base = new URL(sfUrl);
      base.pathname = `/lightning/cmp/AIM__aime`;
      base.searchParams.set('AIM__threadId', threadId);

      setShowSpinner(false);
      window.location.href = base.toString();
    }
  }, [threadId, sfUrl]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: 2 }}>
      {error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <>
          {showSpinner && <CircularProgress />}
          <Typography>{message}</Typography>
        </>
      )}
    </Box>
  );
};

export default AimeThreadRedirect;